<template>
    <section :ref="selectID" class="ui-input ui-select-date" :class="[open ? 'open' : '', size]">
        <div v-if="label" class="label">
            <span v-html="label" />

            <span v-if="required" class="label-required">*</span>
        </div>

        <div class="ui-select-box">
            <div class="selected" :class="{'selected-group': groupicon}" @click="toggle">
                <div>{{ selectedText }}</div>
            </div>

            <span v-if="groupicon" class="group" :style="{'background': groupIconBackground}">
                <i :class="groupicon" :style="{'color': groupIconColor}"/>
            </span>

            <div v-if="open" class="options">
                <section class="list" :class="listType === 'normal' ? 'active' : ''">
                    <div v-if="listType == 'custom-dates' ? 'active' : ''" class="custom-dates">
                        <div v-if="!sameOrUpperToday && invalidDate" class="warning">
                            <div>Você não pode selecionar esta data!</div>
                            <div>Selecione uma <strong>data anterior</strong> ao dia de hoje.</div>
                        </div>
                        <div class="fields">
                            <label>
                                <span>Data Inicial:</span>
                                <input
                                    v-model="start_date"
                                    :min="minStartDate"
                                    :max="end_date || maxDate"
                                    type="date"
                                />
                            </label>
                            <label>
                                <span>Data Final:</span>
                                <input
                                    v-model="end_date"
                                    :min="start_date || minDate"
                                    :max="maxEndDate"
                                    type="date"
                                />
                            </label>
                        </div>
                        <div class="control">
                            <button type="button" @click.stop.prevent="cancel">Cancelar</button>
                            <button
                                type="button"
                                :disabled="checkDateExists || invalidDate"
                                @click.stop.prevent="confirm"
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                    <div v-if="listType == 'normal' ? true : false" class="items">
                        <ul>
                            <li v-for="option in getCorrectOptions" :key="option.id">
                                <button
                                    type="button"
                                    :class="{ active: setActive(option) }"
                                    @click.stop.prevent="select(option)"
                                >
                                    {{ option.label }}
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    @click.stop.prevent="setListType('custom-dates')"
                                >
                                    Informar datas
                                </button>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>

<script>
	const moment = require('moment')
	require('moment/locale/pt-br')

	export default {
		name :'ui-date-range',

		props: {
			label: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para alterar o tamanho do input
			 */
			size: {
				type: String,
				required: false,
				default: 'md',
			},
			value: {
				type: String,
				required: false,
				default: '',
			},
			/**
			 * Utilize para alterar as opções do date-range.
			 */
			hideOptions: {
				type: Array,
				required: false,
				default() {
					return []
				} 
			},
			/**
			 * Placeholder que irá aparecer quando nenhum item estiver selecionado
			 */
			placeholder: {
				type: String,
				required: false,
				default: 'Selecione a data',
			},
			/**
			 * Será possível escolher a data de hoje ou datas acima da data de hoje na opção "Informar datas"?
			 */
			sameOrUpperToday: {
				type: Boolean,
				required: false,
				default: true,
			},
			/**
			 * Utilize para adicionar um icone no group
			 */
			groupicon: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar uma cor no icone do group
			 */
			groupIconColor: {
				type: String,
				default: ''
			},
			/**
			 * Utilize para adicionar um background no icone do group
			 */
			groupIconBackground: {
				type: String,
				default: ''
			},
			/**
			 * define o input como required em html5 e aplica o operador '*' na label
			 */
			required: {
				type: Boolean,
				required: false,
				default: false,
			},
			name: {
				type: String,
				required: false,
				default: null
			},
			/**
			 * Define o range máximo entre a data inicial e final
			 */
			maxRange: {
				type: Object,
				required: false,
				default() {
					return null
				}
			},
			/**
			 * Define uma data máxima para a data de início e fim
			 */
			maxDate: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Define uma data mínima para a data de início e fim
			 */
			minDate: {
				type: String,
				required: false,
				default: ''
			}
		},
		data() {
			return {
				open: false,
				listType: 'normal',
				start_date: '',
				end_date: '',
				month: '',
				id: this._uid,
				selected: '',
				options: [
					{
						id: 1,
						label: 'Todos',
						value: () => {
							return this.clearDates()
						},
					},
					{
						id: 2,
						label: 'Hoje',
						value: () => {
							return this.getData(0, 'd')
						},
					},
					{
						id: 3,
						label: 'Ontem',
						value: () => {
							return this.beforeToday()
						},
					},
					{
						id: 4,
						label: 'Últimos 7 dias',
						value: () => {
							return this.getData(7, 'd')
						},
					},
					{
						id: 5,
						label: 'Últimos 30 dias',
						value: () => {
							return this.getData(30, 'd')
						},
					},
					{
						id: 6,
						label: 'Este mês',
						value: () => {
							return this.getThisMonth()
						},
					},
					{
						id: 7,
						label: 'Mês anterior',
						value: () => {
							return this.getMonthBefore()
						},
					},
				],
				invalidDate: false,
			}
		},

		computed: {
			selectID() {
				return 'select_date_' + this.id
			},
			valueComputed() {
				return this.start_date && this.end_date ? this.start_date + '_' + this.end_date : null
			},
			selectedText() {
				return this.selected.label
			},
			checkDateExists() {
				return this.start_date && this.end_date ? false : true
			},
			getListType() {
				return this.listType === 'custom-date' ? 'active' : ''
			},
			getCorrectOptions() {
				return this.hideOptions?.length
					? this.options.filter(option => !this.hideOptions.includes(option.label))
					: this.options
			},
			/**
			 * Computed property que define a data mínima para a data inicial, de acordo com
			 * a regra de range máximo das datas
			 */
			minStartDate() {
				let min = ''
				if (this.maxRange && this.end_date) {
					min = moment(this.end_date, 'YYYY-MM-DD')
						.subtract(this.maxRange.value, this.maxRange.type)
						.format('YYYY-MM-DD')
				}

				// Verifica se foi configurada uma data mínima global para o intervalo
				if (this.minDate && moment(min, 'YYYY-MM-DD').isBefore(this.minDate)) min = this.minDate

				return min
			},
			/**
			 * Computed property que define a data máxima para a data final, de acordo com
			 * a regra de range máximo das datas
			 */
			maxEndDate() {
				let max = '9999-12-31'
				if (this.maxRange && this.start_date) {
					max = moment(this.start_date, 'YYYY-MM-DD')
						.add(this.maxRange.value, this.maxRange.type)
						.format('YYYY-MM-DD')
				}

				// Verifica se foi configurada uma data mínima global para o intervalo
				if (this.maxDate && moment(max, 'YYYY-MM-DD').isAfter(this.maxDate)) max = this.maxDate

				return max
			}
		},

		watch: {
			/**
			 * Observa por mudanças na prop value
			 */
			value(newVal, oldVal) {
				if (newVal != oldVal) {
					this.invalidDate = false
					this.loadValue()
				}
			},
			/**
			 * Observa por mudanças na data mínima de início de modo a alterar a data de início caso
			 * necessário
			 */
			minStartDate(value) {
				// Verifica se foi definido um interválo máximo entre as datas de início e fim
				if (this.start_date &&
					this.maxRange &&
					moment(value, 'YYYY-MM-DD').isAfter(this.start_date)) {
					this.start_date = value
				}
			},
			/**
			 * Observa por mudanças na data máxima de fim de modo a alterar a data de fim caso
			 * necessário
			 */
			maxEndDate(value) {
				// Verifica se foi definido um interválo máximo entre as datas de início e fim
				if (this.end_date &&
					this.maxRange &&
					moment(value, 'YYYY-MM-DD').isBefore(this.end_date)) {
					this.end_date = value
				}
			}
		},

		created() {
			window.addEventListener('click', this.close)

			this.$root.$on('clear-all-dates', () => {
				this.clearDates()
			})

			/**
			 * Recebe o valor emitido por 'input' e emite, além deste valor, o nome do campo
			 * onde foi selecionado, para identificar quem o enviou e salvar na localStorage
			 * Assim é possível associar a informaçao salva ao seu respectivo campo ao recarregar a tela.
			 * 
			 */
			this.$on('input', value => {
				const params = { value, fieldName: this.name }
				this.$emit('selected', params)
			})
		},

		mounted() {
			this.$nextTick(() => {
				this.loadValue()
			})
		},

		beforeDestroy() {
			this.$root.$off('clear-all-dates')
			this.$root.$off('input')
			window.removeEventListener('click', this.close)
		},

		methods: {
			toggle() {
				this.open = !this.open
			},
			close(e) {
				if (!this.$refs[this.selectID].contains(e.target)) {
					this.open = false
				}
			},
			getData(value, type, subtractOnEnd, valueSubtractOnEnd, typeSubtractOnEnd) {
				this.start_date = moment().subtract(value, type).format('YYYY-MM-DD')
				this.end_date = subtractOnEnd
					? moment().subtract(valueSubtractOnEnd, typeSubtractOnEnd).format('YYYY-MM-DD')
					: moment().format('YYYY-MM-DD')
			},
			beforeToday() {
				this.start_date = moment().subtract(1, 'd').format('YYYY-MM-DD')
				this.end_date = this.start_date
			},
			getMonthBefore() {
				this.start_date = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
				this.end_date = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
			},
			getThisMonth() {
				this.start_date = moment().startOf('month').format('YYYY-MM-DD')
				this.end_date = moment().endOf('month').format('YYYY-MM-DD')
			},
			select(option) {
				this.open = false
				this.selected = option
				option.value()

				this.$emit('input', this.valueComputed)
			},
			setActive(option) {
				return option.id == this.selected.id ? true : false
			},
			cancel() {
				this.listType = 'normal'
				this.clearDates()
				this.$emit('input', this.valueComputed)
			},
			clearDates() {
				this.start_date = ''
				this.end_date = ''
				this.invalidDate = false

				this.selected = {}
				this.selected.label = this.placeholder
			},
			confirm() {
				this.checkDate()

				if (this.checkDateExists || this.invalidDate) return

				this.open = false
				this.$emit('input', this.valueComputed)
				this.selected = {}

				let start_date = moment(this.start_date).format('DD-MM-YYYY')
				let end_date = moment(this.end_date).format('DD-MM-YYYY')

				this.selected.label = start_date + ' até ' + end_date
			},
			checkDate() {
				const today = moment().format('YYYY-MM-DD')

				if (!moment(this.end_date).isAfter(this.start_date)) {
					this.end_date = this.start_date
				}

				// Checks if the selected date is equal to today's date or greater
				if (!this.sameOrUpperToday) {
					if (
						moment(this.start_date).isSameOrAfter(today) ||
						moment(this.end_date).isSameOrAfter(today)
					) {
						this.invalidDate = true
						return
					}
					this.invalidDate = false
				}
			},
			setListType(type) {
				this.listType = type

				// Reset the previous dates
				if (type == 'custom-dates' && !this.sameOrUpperToday) this.clearDates()
			},
			/**
			 * Seta os dados da opção selecionada de acordo com a prop value
			 */
			loadValue() {
				const validOption = this.value
					? this.getCorrectOptions.find(option => {
						option.value()
						return this.value === this.valueComputed
					})
					: { label: 'Selecione', value: null }

				if (validOption) {
					this.selected = validOption

				} else {
					this.setListType('custom-dates')
					const dates = this.value ? this.value.split('_') : []
					if (dates.length) {
						this.start_date = dates[0]
						this.end_date = dates[1]
						this.selected = {}
						this.selected.label = dates[0].split('-').reverse().join('/') + ' até ' + dates[1].split('-').reverse().join('/')
					}
				}
			}
		},
	}
</script>

<style lang="stylus" :scoped="true">
	@import './styles.styl'
</style>
